import { Maybe, fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../CurrentUserStore';
import { emptyFragment } from '../../../../EmptyFragment';
import { findLink } from '../../../../LinkyLinky';
import OrganizationFilterTypeahead from './OrganizationFilterTypeahead';
import { StringOption } from '../../../Options/Types';

interface Props {
  selectedOrganization: Maybe<StringOption>;
  updatingOrganizationParameters: (option: StringOption) => void;
  className?: string;
}

const handleFilterChange =
  (updatingOrganizationParameters: Props['updatingOrganizationParameters']) =>
  (option: StringOption) => {
    fromEmpty(option.value).do(() => updatingOrganizationParameters(option));
  };

function OrganizationFilter({
  updatingOrganizationParameters,
  selectedOrganization,
  className,
}: Props) {
  return findLink('options', currentUserStore.links)
    .map((link) => (
      <div className={className}>
        <OrganizationFilterTypeahead
          endpoint={link}
          name="organization"
          label={'Organization'}
          onChange={handleFilterChange(updatingOrganizationParameters)}
          initialValue={selectedOrganization}
          labelClassname="py-1.5 text-xs font-semibold text-gray-800 block"
          className="w-full"
        />
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(OrganizationFilter);
